import { graphql } from 'react-relay';

export const deleteLibraryMaterialMutation = graphql`
    mutation deleteLibraryMaterialMutation($deleteLibraryMaterialId: UUID!) {
        deleteLibraryMaterial(id: $deleteLibraryMaterialId) {
            id
        }
    }
`;
